export enum InventoryActionTypes {
  SET_STORAGE_JIT_CONFIG = "SET_STORAGE_JIT_CONFIG",
  UPDATE_STORAGE_JIT_CONFIG = "UPDATE_STORAGE_JIT_CONFIG",
  SET_JIT_REPLENISHMENT_STRATEGIES = "SET_JIT_REPLENISHMENT_STRATEGIES",
}
